// extracted by mini-css-extract-plugin
module.exports = {"activityMainContent":"activity_activityMainContent__BNqBL","bannerContent":"activity_bannerContent__7VWP0"};